import * as React from "react";
import { UserGroupType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUnitSummaryNode } from "../../../../../models/unit/unitSummaryNode";
import { List } from "../../../../framework/List/List";
import { PanelTitle } from "../../../../framework/Panel/PanelTitle";
import { Box } from "@mui/material";
import { TUnitPermission } from "source/models/unit/unitPermission";

export interface IUnitPermissionSummaryTableNewProp {
    classes?: string;
    unitNode: IUnitSummaryNode;
    parentName: string;
    unitPermissions: TUnitPermission[];
    showInheritedPermissions: boolean;
    showUserGroups: boolean;
    showUsers: boolean;
    filter: string;
}

export class UnitPermissionSummaryTableNew extends React.Component<IUnitPermissionSummaryTableNewProp, {}> {
    render() {
        const props = this.props;
        const unitNode = props.unitNode;
        if (!unitNode) return null;
        const filterLow = props.filter.toLowerCase();
        const userGroups = unitNode.userGroups.filter(i => (props.showInheritedPermissions || i.permission.isExplicitPermission) &&
            (props.showUserGroups && i.type === UserGroupType.Normal || props.showUsers && i.type === UserGroupType.Fixed) &&
            (!props.filter || i.name.toLowerCase().indexOf(filterLow) > -1));
        const unitTitle = Translations.Unit + ": " + (props.parentName ? props.parentName + " / " : "") + unitNode.name;
        return (
            <div className={(props.classes ? " " + props.classes : "")}>
                {userGroups.length > 0 &&
                    <Box display="flex" flexDirection="column" sx={{ marginBottom: "1.5rem" }}>
                        <PanelTitle title={unitTitle} />
                        <List
                            intialized={true}
                            isLoading={false}
                            hasMore={false}
                            header={{
                                columns: [
                                    { size: 6, column: "userGroup", content: Translations.UserGroup + "/" + Translations.User },
                                    { size: 6, column: "name", content: Translations.Permission }
                                ]
                            }}
                            lines={
                                userGroups.map((userGroup) => {
                                    const permission = userGroup.permission.permission;
                                    const permissionText = props.unitPermissions.find(i => i.level === permission &&
                                        i.levelA === userGroup.permission.additionalPermissionA &&
                                        i.levelB === userGroup.permission.additionalPermissionB &&
                                        i.levelC === userGroup.permission.additionalPermissionC)?.title ?? Translations.Unkown;
                                    return {
                                        columns: [
                                            { size: 6, content: userGroup.name },
                                            { size: 6, content: permissionText }
                                        ],
                                        id: userGroup.name,
                                        classes: userGroup.permission.isExplicitPermission ? "" : "inherited"
                                    };
                                })
                            }
                            sortColumn={""}
                            sortOrderIsAsc={true}
                            selectedId={""}
                            onSetSelectedIds={null}
                            onSearchLines={null}
                        />
                    </Box>
                }
                {unitNode.children.map((childUnitNode) =>
                    <UnitPermissionSummaryTableNew
                        key={childUnitNode.id}
                        unitNode={childUnitNode}
                        parentName={unitNode.name}
                        unitPermissions={props.unitPermissions}
                        showInheritedPermissions={props.showInheritedPermissions}
                        showUserGroups={props.showUserGroups}
                        showUsers={props.showUsers}
                        filter={props.filter}
                    />
                )}
            </div>
        );
    }
}